import React from "react";
import { Link } from "react-router-dom";

const FestivalCard = ({ title, imageName, description, slug }) => {
  return (
    <Link to={`/festival/${slug}`}>
      <div className="tw-bg-white tw-rounded-lg tw-overflow-hidden tw-shadow-md hover:tw-shadow-xl tw-transition-transform tw-duration-300 hover:tw-scale-105 tw-h-full tw-flex tw-flex-col">
        <div className="tw-relative tw-h-48 tw-overflow-hidden">
          <img
            src={imageName}
            alt={title}
            className="tw-w-full tw-h-full tw-object-cover"
            loading="lazy"
          />
        </div>
        <div className="tw-p-4 tw-flex tw-flex-col tw-flex-grow">
          <h2 className="tw-font-bold tw-text-xl tw-mb-2 tw-text-gray-800">
            {title}
          </h2>
          <p className="tw-text-gray-600 tw-flex-grow tw-overflow-hidden tw-line-clamp-3">
            {description}
          </p>
        </div>
      </div>
    </Link>
  );
};

export default FestivalCard;
